import { LiveAnnouncer } from '@angular/cdk/a11y';
import { OnInit, Component, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store/state';
import { getPreProvision } from 'src/app/store/selectors/fleet-manager.selector';
import { FleetManagementService } from '../../services/fleet-management.service';
import { AuthService } from '../../../../auth/auth.service';
import { ToastPanelType } from 'src/app/config/app-constants';
import { ToastService } from '../../../../shared/services/toast.service';
import { FleetConfigurationService } from '../../services/fleet-configuration.service';
import { FleetManagerActions, OrganizationsActions } from 'src/app/store/actions';
import { SearchBarComponent } from 'src/app/shared/components/search-bar/search-bar.component';
import { DeploymentFormDialogComponent, DeploymentFormDialogComponentData } from '../deployment-form-dialog/deployment-form-dialog.component';
import { Device } from '../../models/device.model';
import { OnboardVmDialogComponent } from '../onboard-vm-dialog/onboard-vm-dialog';

@Component({
    selector: 'app-pre-provisioned',
    templateUrl: './pre-provisioned.component.html',
    styleUrls: ['./pre-provisioned.component.scss'],
    standalone: false
})
export class PreProvisionedComponent implements OnInit {

  idName = 'ID Number';
  agentType = 'Agent Type';
  connected = 'Connected';
  lastUpdated = 'Last Updated'
  displayedColumns: string[] = ['idName', 'deviceType', 'macAddress', 'osDistro', 'connected', 'lastUpdated']; //, 'configure'
  dataSource: MatTableDataSource<any>;
  unprovisioned: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(SearchBarComponent, { static: true }) childComponent: SearchBarComponent;
  filterText = '';
  canEditOsDistro = false;
  osDistroOptions: string[] = [];
  editingOsDistroRow: any = null;

  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    public dialog: MatDialog,
    public fleetManagementService: FleetManagementService,
    public fleetConfigService: FleetConfigurationService,
    public auth: AuthService,
    public toastService: ToastService,
    public store: Store<State>) {
    this.loadDevices();
  }

  loadDevices() {
    this.store.select(getPreProvision).subscribe(res => {
      if (res) {
        const Data: any = res;
        this.unprovisioned = Data.sort((a, b) => {
          if (a.edgeDeviceId.toLowerCase() > b.edgeDeviceId.toLowerCase()) { return 1; }
          if (a.edgeDeviceId.toLowerCase() < b.edgeDeviceId.toLowerCase()) { return -1; }
          return 0;
        });
        this.dataSource = new MatTableDataSource(this.unprovisioned);

        if (this.filterText) {
          this.filterData(this.filterText);
        }
      }
    });
  }

  ngOnInit() {
    this.auth.profile$.subscribe({
      next: (profile) => {
        this.canEditOsDistro = profile.hasRole('Parata Dev');
      },
      error: () => {
        this.canEditOsDistro = false;
      }
    });

    this.fleetManagementService.getOsDistros().subscribe({
      next: (options) => { this.osDistroOptions = options; },
      error: () => { this.osDistroOptions = []; }
    });

    this.fleetConfigService.getConfigTemplates().subscribe(
      (response) => {
        this.store.dispatch(FleetManagerActions.getFTConfiguration({ data: response }));
      });
  }

  openSystemConfigDialog(deviceConfig: Device) {
    this.dialog.open(DeploymentFormDialogComponent,
      {
        disableClose: true,
        backdropClass: 'lgDialog',
        data: { edgeDeviceId: deviceConfig.edgeDeviceId, provisioned: false } as DeploymentFormDialogComponentData
      });
  }

  announceSortChange(sortState: Sort) {
    //sorting
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
    let data: any;
    if (this.dataSource?.data) {
      data = this.dataSource.data;
    } else {
      data = this.dataSource;
    }

    const sortData = data.sort((a, b) => {
      switch (this.sort.active) {
        case 'idName':
          return this.stringCompare(a.edgeDeviceId, b.edgeDeviceId, sortState.direction);
        case 'connected':
          return this.stringCompare(a.connectionState, b.connectionState, sortState.direction);
        case 'lastUpdated':
          return this.dateCompare(new Date(a.connectionStateUpdatedTime), new Date(b.connectionStateUpdatedTime), sortState.direction);
        default:
          return 0;
      }
    });
    this.dataSource = new MatTableDataSource(sortData);
  }

  stringCompare(a, b, direction) {
    if (a && b) {
      if (direction == 'desc') {
        if (a.toLowerCase() < b.toLowerCase()) { return 1; }
        if (a.toLowerCase() > b.toLowerCase()) { return -1; }
      } else {
        if (a.toLowerCase() > b.toLowerCase()) { return 1; }
        if (a.toLowerCase() < b.toLowerCase()) { return -1; }
      }
    }
    return 0;
  }

  dateCompare(a, b, direction) {
    if (a && b) {
      if (direction == 'desc') {
        if (a < b) { return 1; }
        if (a > b) { return -1; }
      } else {
        if (a > b) { return 1; }
        if (a < b) { return -1; }
      }
    }
    return 0;
  }

  filterData(filter) {
    this.filterText = filter;

    const filterLowerCase = filter.toLowerCase();
    this.filterText = filter;

    const data = this.unprovisioned;

    let filteredData = data;
    if (filterLowerCase != '') {

      filteredData = filteredData.filter((item) => (
        item.edgeDeviceId.toLowerCase().includes(filterLowerCase)
      ));
    }
    this.dataSource = new MatTableDataSource(filteredData);
  }

  openAddVmDialog() {
    this.dialog.open(OnboardVmDialogComponent,
      {
        backdropClass: 'mdDialog'
      });
  }

  onOsDistroChange(element: any, value: string) {
    this.fleetManagementService.updateOsDistro(element.edgeDeviceId, value).subscribe({
      next: () => {
        element.osDistro = value;
        this.editingOsDistroRow = null;
        this.toastService.openToast('OS Distro updated successfully.', ToastPanelType.done);
      },
      error: (err) => {
        console.error('Failed to update OS distro', err);
        this.toastService.openToast('Failed to update OS Distro.', ToastPanelType.error);
      }
    });
  }

  cancelOsDistroEdit() {
    this.editingOsDistroRow = null;
  }

  refreshDevices() {
    this.store.dispatch(FleetManagerActions.getIOTDeviceDetails());
    this.store.dispatch(OrganizationsActions.getOrganizations());
  }
}